import { render, staticRenderFns } from "./popularity.vue?vue&type=template&id=1e5ecafe&scoped=true"
import script from "./popularity.vue?vue&type=script&lang=js"
export * from "./popularity.vue?vue&type=script&lang=js"
import style0 from "./popularity.vue?vue&type=style&index=0&id=1e5ecafe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e5ecafe",
  null
  
)

export default component.exports